import Input from '@material-ui/core/Input'
import InputAdornment from '@material-ui/core/InputAdornment'
import { makeStyles } from '@material-ui/core/styles'
import SearchIcon from '@material-ui/icons/Search'
import clsx from 'clsx'
import React from 'react'
import { FilterProps } from 'react-table'

const useStyles = makeStyles({
    inputSelectText: {
        fontSize: 14,
        height: '1.4em',
        padding: '8px 0 8px',
    },
})

const FilterTextInput: React.FC<FilterProps<any>> = ({
    column: { id, filterValue, setFilter },
}) => {
    const classes = useStyles()
    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) =>
        setFilter(e.currentTarget.value || undefined)
    return (
        <Input
            value={filterValue || ''}
            onChange={onInputChange}
            inputProps={{
                className: clsx(classes.inputSelectText, `filter-input-${id}`),
                'aria-label': `Filter by ${id}`,
            }}
            fullWidth
            endAdornment={
                <InputAdornment position="end">
                    <SearchIcon fontSize="small" />
                </InputAdornment>
            }
        />
    )
}

export default FilterTextInput
